import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const AchievementGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 80px);
  grid-gap: 20px;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
  ${(props) =>
    props.isXPPage &&
    css`
      margin: 0px;
    `}
`;

export const AchievementContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const AchievementIcon = styled.div`
  ${(props) =>
    props.image &&
    css`
      background: url(${props.image});
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    `}
  width: 80px;
  height: 80px;
  margin-bottom: 10px;

  ${(props) =>
    !props.acquired &&
    css`
      opacity: 0.5;
    `}
`;

export const AchievementLabel = styled.span`
  color: ${colors.darkGray};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  ${(props) =>
    !props.acquired &&
    css`
      opacity: 0.5;
    `}
`;

export const AchievementTooltipLabel = styled.span`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 5px;
`;

export const AchievementDescription = styled.p`
  font-size: 13px;
  margin: 0;
`;

export const ContentContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 220px;
  margin-right: 10px;

  @media (max-width: 1024px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

export const RightContainer = styled.div`
  width: 100%;
  @media (min-width: 1024px) {
    margin-left: 15px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 667px) {
    flex-direction: column;
    height: 75px;
  }
`;
